import { render, staticRenderFns } from "./weddingPackage.vue?vue&type=template&id=5fde51b0&scoped=true"
import script from "./weddingPackage.vue?vue&type=script&lang=js"
export * from "./weddingPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fde51b0",
  null
  
)

export default component.exports